import React from "react";
import { formatNumbers } from "../../../helpers/functions.tsx";
import { Transaction } from "../../../models/User";
import { FaPencilAlt } from "react-icons/fa";
import "../../../styles/Transaction.css";

interface ITransaction {
    transactions: Transaction[];
    startIndex?: number;
}

export const TransactionDetails = (props: ITransaction) => {
    const { transactions, startIndex = 0 } = props;

    return (
        <>
            {transactions.length > 0 && (
                transactions.map((tx, index) => {
                    const isCredit = tx.transactionType === 'CreditAdjustment';
                    const isDebit = tx.transactionType === 'DebitAdjustment';
                    const value = isCredit ? tx.amount : isDebit ? -tx.amount : 0;
                    const rowBg = (startIndex + index) % 2 === 0 ? "#e6e6e6" : "#ffffff";

                    return (
                        <tr key={tx.id} className="transaction-row-t" style={{ backgroundColor: rowBg }}>
                            <td colSpan={8}>
                                <div className="bet-selection-container">
                                    <div className="d-flex align-items-center">
                                        <span className="body-letters black-letters body-letters-hanging">
                                            <FaPencilAlt className="transaction-icon" />
                                            <span className="fw-bold inter">{tx.description}</span>
                                            &nbsp;
                                            <span
                                                style={{
                                                    color: isCredit ? "green" : "red",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {isCredit ? "C" : "D"}
                                            </span>
                                        </span>
                                    </div>

                                    <div
                                        className={`selection-money ${
                                            value < 0 ? 'negative black-letters'
                                                : value > 0 ? 'positive black-letters'
                                                    : 'zero black-letters'
                                        }`}
                                    >
                                        {value > 0 ? '+ $' : value < 0 ? '- $' : '$'}
                                        {formatNumbers(Math.abs(value))}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    );
                })
            )}
        </>
    );
};
